import { combineReducers } from 'redux';
import counties from './counties';
import categories from './categories';
import dropDownShow from './drop-down-show';
import filters from './filters';
import filteredEvents from './filtered-events';
import loadingFilters from './loading-filters';
import totalEvents from './total-events';
import singleEvent from './single-event';
import festivalEvent from './festival-event';
import promotedEvents from './promoted-events';
import searchSuggestions from './search-suggestions';
import placeReducer from './place-reducer';
import banners from './banners';
import menuState from './menu-state';
import isLoggedIn from './is-logged-in';
import showModalWindow from './show-modal-window';
import showModalType from './show-modal-type';
import userProfile from './user-profile';
import resetLinkSent from './reset-link';
import staticPageData from './static-page';
import piletileviTopEvents from './piletilevi-top';
import recentEvents from './recent-events';
import tempStore from './temp-store';
import loginError from './login-error';

export default combineReducers({
    counties,
    categories,
    dropDownShow,
    filters,
    filteredEvents,
    loadingFilters,
    totalEvents,
    singleEvent,
    promotedEvents,
    searchSuggestions,
    placeReducer,
    banners,
    menuState,
    isLoggedIn,
    showModalWindow,
    userProfile,
    showModalType,
    resetLinkSent,
    staticPageData,
    piletileviTopEvents,
    recentEvents,
    festivalEvent,
    tempStore,
    loginError,
});

export type RootState = ReturnType<typeof combineReducers>
